var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeriod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.385 18v-3.115H4.5V18H1.385zm3.807 0v-3.115h3.462V18H5.192zm-3.807-3.808v-3.461H4.5v3.461H1.385zm3.807 0v-3.461h3.462v3.461H5.192zm-3.807-4.154V6.923H4.5v3.115H1.385zM9.346 18v-3.115h3.462V18H9.346zm-4.154-7.962V6.923h3.462v3.115H5.192zM13.5 18v-3.115h3.115V18H13.5zm-4.154-3.808v-3.461h3.462v3.461H9.346zM5.538 4.846a.356.356 0 0 1-.346.346H4.5a.356.356 0 0 1-.346-.346V1.731c0-.184.162-.346.346-.346h.692c.184 0 .346.162.346.346v3.115zm7.962 9.346v-3.461h3.115v3.461H13.5zm-4.154-4.154V6.923h3.462v3.115H9.346zm4.154 0V6.923h3.115v3.115H13.5zm.346-5.192a.356.356 0 0 1-.346.346h-.692a.356.356 0 0 1-.346-.346V1.731c0-.184.162-.346.346-.346h.692c.184 0 .346.162.346.346v3.115zM18 4.154c0-.757-.627-1.385-1.385-1.385h-1.384V1.731C15.23.779 14.45 0 13.5 0h-.692c-.952 0-1.731.779-1.731 1.73v1.04H6.923V1.73C6.923.78 6.144 0 5.193 0H4.5c-.952 0-1.73.779-1.73 1.73v1.04H1.384C.627 2.77 0 3.396 0 4.153V18c0 .757.627 1.385 1.385 1.385h15.23c.758 0 1.385-.628 1.385-1.385V4.154z",
    fill: "#000",
    fillRule: "evenodd",
    fillOpacity: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriod);
export default __webpack_public_path__ + "static/media/period.451436b4debaabd4776d3111fbd41f6f.svg";
export { ForwardRef as ReactComponent };